import { upperFirst } from 'lodash';
import { useTranslation } from 'react-i18next';

import { StyledText } from '../../../BookingStagesInformation/BookingStagesInformation.styles';

const BookingLandlordRegistrationTaxInformation = () => {
  const { t } = useTranslation(['bookingStageInformation']);
  const textBeforeLink = upperFirst(t('landlordRegistrationTaxWarning')).split(
    'https://www.zappyrent.com/it/help',
  )[0];
  const textAfterLink = upperFirst(t('landlordRegistrationTaxWarning')).split(
    'https://www.zappyrent.com/it/help',
  )[1];
  return (
    <StyledText>
      {'⚠️'}
      {textBeforeLink}
      <a
        href="https://www.zappyrent.com/it/help"
        target="_blank"
        rel="noopener noreferrer"
      >
        zappyrent.com/it/help
      </a>
      {textAfterLink}
    </StyledText>
  );
};

export default BookingLandlordRegistrationTaxInformation;
